import { useEffect, useCallback } from "react";
import { useParameter, useSubscriptionProviderContext } from "../../../shared";

import { useSlideTitle } from "../hooks/useSlideTitle";
import { ApplyParameters } from "../../../shared/components/SubscriptionProvider/SubscriptionProvider.types";

export function useSubscription() {
  const title = useSlideTitle();
  const subtitle = "";
  const {
    actions: { setParameters, setTitle, setSubtitle, setApplyParametersFunction },
  } = useSubscriptionProviderContext();

  const [calendar] = useParameter<number[]>("@calendar");

  const [commodities, setCommodities] = useParameter<number>("@commodities");
  const [commDisplay, setCommDisplay] = useParameter<number>("@commodities_display");

  useEffect(() => {
    setTitle(title);
    setSubtitle(subtitle);
    setParameters({
      "@commodities": commodities,
      "@commodities_display": commDisplay,
      "@calendar": calendar,
    });
  }, [title, subtitle, commDisplay, calendar, commodities, setParameters]);

  const applyParameters = useCallback(
    (parameters: ApplyParameters) => {
      setCommodities((parameters["@commodities"].value as string[]).map(Number)[0]);
      setCommDisplay((parameters["@commodities_display"].value as string[]).map(Number)[0]);
    },
    [setCommodities, setCommDisplay]
  );

  useEffect(() => {
    setApplyParametersFunction(applyParameters);
  }, [setApplyParametersFunction, applyParameters]);
}
